<template>
  <Dropdown
    v-model="selectedLanguage"
    :options="languages"
    scroll-height="fit-content"
    :pt-options="{ mergeProps: true, mergeSections: true }"
    class="flex items-center gap-[6px] border-none shadow-none"
    :pt="{
      input: {
        class: ['text-[--v3-theme-highlighttextcolor] v3-h6-regular-400-line-height-1.5 p-0']
      },
      trigger: {
        class: ['size-[16px] text-[--v3-theme-highlighttextcolor]']
      },
      wrapper: {
        class: ['frs-hide-scroll'],
      }
    }"
    option-label="label"
    @change="emit('change', $event.value.code)"
  >
    <template #dropdownicon>
      <Icon
        :width="24"
        :height="24"
        class="title"
        name="caret-down-filled"
      />
    </template>
  </Dropdown>
</template>

<script lang="ts" setup>
import Dropdown from 'primevue/dropdown';
import { onBeforeMount, ref } from 'vue';

import Icon from '@/common/components/atoms/Icon';

interface Props {
  value?: string
}

const props = withDefaults(defineProps<Props>(), {
  value: 'en',
});

const emit = defineEmits<{
  change: [ value: string ],
}>();

const languages = ref([
  {
    label: 'EN',
    code: 'en',
  },
  {
    label: 'FR',
    code: 'fr',
  },
  {
    label: 'UA',
    code: 'ua',
  },
  {
    label: 'TR',
    code: 'tr',
  },
  {
    label: 'DE',
    code: 'de',
  },
  {
    label: 'ES',
    code: 'es',
  },
  {
    label: 'IT',
    code: 'it',
  },
]);

const selectedLanguage = ref(null);

onBeforeMount(() => {
  selectedLanguage.value = languages.value.find(
    (language) => language.code === props.value,
  );
});
</script>

<style scoped>
.dropdown-title {
  color: var(--v3-global-textsecondarycolor);
}
</style>
